/* Publish by EComposer at 2026-11-01 16:55:33*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-q6evl4187wm"]=  window.__ectimmers["ecom-q6evl4187wm"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-q6evl4187wm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q6evl4187wm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zz3mlv97sdf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zz3mlv97sdf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l9yvelkg4tf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l9yvelkg4tf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j316mur8km').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j316mur8km', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-066f8ehy2ugr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-066f8ehy2ugr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1q4esrawkbl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1q4esrawkbl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o8r2077s4ao').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o8r2077s4ao', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4uqgu7pyqim').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4uqgu7pyqim', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-waor39s7wo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-waor39s7wo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kcv6p136uc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kcv6p136uc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-65124lexloq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-65124lexloq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z6yjxwrf9hg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z6yjxwrf9hg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xrz1azqglzk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xrz1azqglzk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nspz6t2p7f9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nspz6t2p7f9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-woqyz13a4ep').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-woqyz13a4ep', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gmzb8a6zvts').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gmzb8a6zvts', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dk3sfbs91eb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dk3sfbs91eb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ujxhj02v9xo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ujxhj02v9xo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-up222tm1hu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-up222tm1hu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wldloe9g1yb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wldloe9g1yb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wcbqv6q8t2t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wcbqv6q8t2t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fuzre34mxe6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fuzre34mxe6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x22t9wxvb8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x22t9wxvb8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nma30920nns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nma30920nns', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wazw44x685').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wazw44x685', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l5xxse51t7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l5xxse51t7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvv60qu7oaa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvv60qu7oaa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l39paxpn7zl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l39paxpn7zl', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-j7rks8e7n9j"]=  window.__ectimmers["ecom-j7rks8e7n9j"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-j7rks8e7n9j"]["tzwfvke5r"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-j7rks8e7n9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j7rks8e7n9j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nhu7vfb2bs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nhu7vfb2bs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r1dinuzr5v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r1dinuzr5v', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ss2qviji1el').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ss2qviji1el', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1seu3yumz7g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1seu3yumz7g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1x4jke0hd97h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1x4jke0hd97h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9emqjjmkb7p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9emqjjmkb7p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hs2fvufzwp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hs2fvufzwp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ipp18s993w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ipp18s993w', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dnphs3cyjss').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dnphs3cyjss', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bt28xr7vpx8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bt28xr7vpx8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jtqqo108c9a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jtqqo108c9a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-87qn681uxyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-87qn681uxyi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aea9f7o07ys').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aea9f7o07ys', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-db2s5wj98h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-db2s5wj98h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2cdokvesnps').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2cdokvesnps', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4du3ltt8oun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4du3ltt8oun', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ohbfzfkeq3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ohbfzfkeq3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ciiwgh4st8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ciiwgh4st8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qv82q2r08eq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qv82q2r08eq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dttfhyipwxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dttfhyipwxh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pk45na1o7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pk45na1o7a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zpbx2chxu3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zpbx2chxu3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-86t3wpiu45n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-86t3wpiu45n', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iwldks4j57f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iwldks4j57f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xjwz1bfag7o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xjwz1bfag7o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3iudyddbb0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3iudyddbb0o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gfh02h6lmnu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gfh02h6lmnu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6vl2qr141yw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6vl2qr141yw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gu8q8eikhh9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gu8q8eikhh9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-36i01dr38a9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-36i01dr38a9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yxuvi8ogxv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yxuvi8ogxv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4j197w7ghe6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4j197w7ghe6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iajkcpg2jp8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iajkcpg2jp8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hfwb4qntg6l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hfwb4qntg6l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5v2yq59l9fr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5v2yq59l9fr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pd02w0skqwh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pd02w0skqwh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ha9axn5d6qb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ha9axn5d6qb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-73nrv6tuwit').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-73nrv6tuwit', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k1yzyonsup9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k1yzyonsup9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u5suizw6nsm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u5suizw6nsm', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kkkfid7xj3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kkkfid7xj3', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kqzm9jdam6m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kqzm9jdam6m', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}